import React from "react";
import { Container, Grid, Icon } from "semantic-ui-react";

import TemplateMain from "../../components/TemplateMain";

export default function NotFound() {

    const content = (
        <Grid style={{ marginTop: "25%"}}>
            <Grid.Row>
                <Grid.Column textAlign="center">
                    <Icon name="frown outline" size="massive" />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column textAlign="center">
                    <Container text={true} >
                        404 - Página não encontrada
                        </Container>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )

    return (
        <TemplateMain
            loading={false}
            content={content}
        />
    )
}
